// 操作キャラ4人の基礎データ。主Lv・スキル・装備による上乗せは meta が計算する。
import type { CharId } from '../types';

export interface SkillDef {
  name: string;
  desc: string;
  mult: number; // 攻撃力に掛ける倍率
  range: number;
  cd: number; // 使ってから再使用までの自分の手番数
  magic?: boolean; // 防御を半分無視
  splash?: number; // 周囲への割合ダメージ
  delay?: number; // 対象の次の行動を遅らせる（CTBの刻み数）
  leech?: number; // 与ダメの割合を回復
  coreMult?: number; // 本陣への倍率
  buildingMult?: number; // 建物への倍率
  line?: boolean; // 直線の上の相手にしか撃てない
  pierce?: number; // 直線で的の奥へ貫く数
}

export interface CharDef {
  id: CharId;
  name: string;
  kana: string;
  race: string;
  role: string;
  weapon: string; // 専用武器の種類
  base: { hp: number; atk: number; def: number; agi: number; move: number; range: number; magic?: boolean; splash?: number }; // splash：通常攻撃が的の周りにも当たる割合
  skill: SkillDef;
  passive: string; // 説明用
  sprite: { sheet: 'heroes'; col: 0 | 1; row: 0 | 1 };
}

export const CHARS: Record<CharId, CharDef> = {
  akari: {
    id: 'akari',
    name: 'アカリ',
    kana: 'あかり',
    race: '提灯の付喪神',
    role: '術・守り',
    weapon: '提灯杖',
    base: { hp: 140, atk: 52, def: 9, agi: 124, move: 0, range: 2, magic: true },
    skill: { name: '花火', desc: '射程3・1.4倍の魔法＋周囲に50%', mult: 1.4, range: 3, cd: 3, magic: true, splash: 0.5 },
    passive: '通常攻撃が魔法（防御を半分無視）',
    sprite: { sheet: 'heroes', col: 0, row: 0 },
  },
  kazamaru: {
    id: 'kazamaru',
    name: 'カザマル',
    kana: 'かざまる',
    race: '烏天狗',
    role: '機動・武',
    weapon: '羽団扇',
    base: { hp: 134, atk: 43, def: 11, agi: 132, move: 1, range: 1 },
    skill: { name: '疾風', desc: '直線の射程2・1.4倍。直線上の敵と奥の1体まで貫き、次の行動を遅らせる', mult: 1.4, range: 2, cd: 3, delay: 400, line: true, pierce: 1 },
    passive: '移動力+1',
    sprite: { sheet: 'heroes', col: 1, row: 0 },
  },
  suzune: {
    id: 'suzune',
    name: 'スズネ',
    kana: 'すずね',
    race: '鬼',
    role: '建築・攻城',
    weapon: '大槌',
    base: { hp: 178, atk: 49, def: 16, agi: 102, move: 0, range: 1, splash: 0.25 },
    skill: { name: '破城', desc: '1.3倍＋周囲に30%。本陣へ1.5倍・建物へ2倍', mult: 1.3, range: 1, cd: 3, splash: 0.3, coreMult: 1.5, buildingMult: 2 },
    passive: '大槌：通常攻撃が周囲にも25%。建物を1マス遠くまで建てられる。本陣へのダメージ1.15倍',
    sprite: { sheet: 'heroes', col: 0, row: 1 },
  },
  yuzuha: {
    id: 'yuzuha',
    name: 'ユズハ',
    kana: 'ゆずは',
    race: '狐',
    role: '剣・狐火',
    weapon: '刀',
    base: { hp: 142, atk: 50, def: 12, agi: 120, move: 0, range: 1 },
    skill: { name: '狐火斬り', desc: '1.45倍の斬撃、与ダメの20%を回復', mult: 1.45, range: 1, cd: 3, leech: 0.2 },
    passive: '術で与えたダメージの20%を回復',
    sprite: { sheet: 'heroes', col: 1, row: 1 },
  },
};
